export default __webpack_public_path__ + "static/media/odin-silver.b469ff49.png";